// Drop-in "this pledge is on a recurring subscription" indicator — reused on the pledge report, order search,
// and devotee pledges/orders. Renders a recurring icon when `recurring` is { provider, sub_id, account };
// clicking opens the shared SubscriptionDetailDialog. Renders nothing when `recurring` is null.
import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import SubscriptionDetailDialog from './SubscriptionDetailDialog';

const PROVIDER_LABEL = { paysimple: 'PaySimple', authnet: 'Authorize.Net' };

export default function RecurringPledgeIndicator({ recurring, size = 'small' }) {
  const [open, setOpen] = useState(false);
  if (!recurring) return null;
  return (
    <>
      <Tooltip title={`On recurring (${PROVIDER_LABEL[recurring.provider] || recurring.provider}) — click for details`}>
        <IconButton size={size} color="primary" onClick={(e) => { e.stopPropagation(); setOpen(true); }} sx={{ p: 0.25 }}>
          <AutorenewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <SubscriptionDetailDialog open={open} onClose={() => setOpen(false)} provider={recurring.provider} subId={recurring.sub_id} account={recurring.account} />
    </>
  );
}
